module.exports = __webpack_public_path__ + "img/proship-ad.173de602.png";